const target = '.anchor-link';
const offset = 100;
const duration = 1000;
jQuery(document).on('ready', function () {
    jQuery(target).click(function () {
        var href = jQuery(this).attr('href');
        jQuery([document.documentElement, document.body]).animate({
            scrollTop: jQuery(href).offset().top - offset
        }, duration);
    });
});
jQuery(document).on('js_event_wpv_pagination_completed', function (event, data) {
    if (data.layout.length > 0 && jQuery(data.layout[0]).find('.wm-news').length > 0) {
        jQuery([document.documentElement, document.body]).animate({
            scrollTop: jQuery(data.layout[0]).offset().top - 200
        }, duration);
    }
});
